(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-spotlight').forEach(function (root) {
      // Image / video gallery — arrows + thumbnails
      var slides = root.querySelectorAll('.product-spotlight__slide');
      var thumbs = root.querySelectorAll('.product-spotlight__thumb');
      var prevBtn = root.querySelector('.product-spotlight__nav-btn--prev');
      var nextBtn = root.querySelector('.product-spotlight__nav-btn--next');

      function pauseSlideMedia(slide) {
        if (!slide) return;
        // Pause native (Shopify-hosted) videos
        slide.querySelectorAll('video').forEach(function (v) {
          try { v.pause(); } catch (e) {}
        });
        // Stop external (YouTube/Vimeo) iframes by reloading their src
        slide.querySelectorAll('iframe').forEach(function (f) {
          var src = f.getAttribute('src');
          if (src) { f.setAttribute('src', src); }
        });
      }

      function goToSlide(index) {
        if (slides.length === 0) return;
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        slides.forEach(function (s, i) {
          var active = i === index;
          s.classList.toggle('is-active', active);
          if (!active) pauseSlideMedia(s);
        });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      }

      function currentIndex() {
        var idx = 0;
        slides.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; });
        return idx;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex() + 1); });

      thumbs.forEach(function (thumb) {
        thumb.querySelector('button').addEventListener('click', function () {
          var idx = parseInt(thumb.dataset.thumbIndex, 10) || 0;
          goToSlide(idx);
        });
      });

      // Centered play button on video slides
      root.querySelectorAll('.product-spotlight__play-btn').forEach(function (playBtn) {
        var wrap = playBtn.closest('.product-spotlight__video-wrap');
        var video = wrap ? wrap.querySelector('video') : null;
        if (!video) return;

        playBtn.addEventListener('click', function () {
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        });
        video.addEventListener('play', function () { playBtn.classList.add('is-hidden'); });
        video.addEventListener('pause', function () { playBtn.classList.remove('is-hidden'); });
        video.addEventListener('ended', function () { playBtn.classList.remove('is-hidden'); });
      });

      // Quantity +/- buttons
      var qtyInput = root.querySelector('.product-spotlight__qty-input');
      root.querySelectorAll('.product-spotlight__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var step = parseInt(btn.dataset.qtyStep, 10) || 0;
          var current = parseInt(qtyInput.value, 10) || 1;
          var next = Math.max(1, current + step);
          qtyInput.value = next;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // Variant pill selection
      var variantInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var addBtn = root.querySelector('[data-add-button]');
      var addLabel = root.querySelector('[data-add-label]');

      function applyVariant(match) {
        if (!match) return;
        if (variantInput) {
          variantInput.value = match.id;
          if (match.available) {
            variantInput.removeAttribute('disabled');
          } else {
            variantInput.setAttribute('disabled', 'disabled');
          }
        }
        if (priceEl) priceEl.textContent = match.price;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.classList.toggle('is-sold-out', !match.available);
          if (addLabel) addLabel.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }

      root.querySelectorAll('.product-spotlight__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var siblings = pill.parentElement.querySelectorAll('.product-spotlight__pill');
          siblings.forEach(function (s) { s.classList.remove('is-active'); });
          pill.classList.add('is-active');

          var optionGroup = pill.closest('.product-spotlight__option');
          var selValueEl = optionGroup ? optionGroup.querySelector('[data-selected-value]') : null;
          if (selValueEl) selValueEl.textContent = pill.dataset.optionValue;

          var selected = [];
          root.querySelectorAll('.product-spotlight__option').forEach(function (group) {
            var active = group.querySelector('.product-spotlight__pill.is-active');
            selected.push(active ? active.dataset.optionValue : null);
          });

          if (!root._variantData) return;
          var match = root._variantData.find(function (v) {
            return (selected[0] == null || v.option1 === selected[0])
              && (selected[1] == null || v.option2 === selected[1])
              && (selected[2] == null || v.option3 === selected[2]);
          });
          applyVariant(match);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.testimonials-section').forEach(function (section) {
      var track = section.querySelector('[data-testimonials-track]');
      var bullets = section.querySelectorAll('.testimonials__bullet');
      if (!track || bullets.length === 0) return;

      var cards = track.querySelectorAll('.testimonials__card');

      // Bullet click → scroll to that card
      bullets.forEach(function (bullet) {
        bullet.addEventListener('click', function () {
          var idx = parseInt(bullet.dataset.bulletIndex, 10) || 0;
          var target = cards[idx];
          if (!target) return;
          track.scrollTo({
            left: target.offsetLeft - track.offsetLeft,
            behavior: 'smooth',
          });
        });
      });

      // IntersectionObserver — update active bullet based on which card is most visible
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              var idx = parseInt(entry.target.dataset.slideIndex, 10) || 0;
              bullets.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
            }
          });
        }, { root: track, threshold: [0, 0.6, 1] });

        cards.forEach(function (card) { observer.observe(card); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.trust-badges-section').forEach((section) => {
      const sliderEl = section.querySelector('slider-component');
      const bullets = section.querySelectorAll('.trust-badges__bullet');
      if (!sliderEl) return;

      const trackId = sliderEl.querySelector('ul[id^="Slider-"]');
      if (!trackId) return;
      const slides = sliderEl.querySelectorAll('li[id^="Slide-"]');

      bullets.forEach((bullet, idx) => {
        bullet.addEventListener('click', (e) => {
          e.preventDefault();
          const target = slides[idx];
          if (!target) return;
          trackId.scrollTo({
            left: target.offsetLeft - trackId.offsetLeft,
            behavior: 'smooth',
          });
        });
      });

      sliderEl.addEventListener('slideChanged', (e) => {
        const current = (e.detail.currentPage || 1) - 1;
        bullets.forEach((b, i) => b.classList.toggle('is-active', i === current));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
